import {ControlValueAccessor, FormControl, NgControl} from '@angular/forms';
import {Directive, Injector, Input, OnInit} from '@angular/core';
import {noop} from 'rxjs';

export const emptyFnWithParameter = (onj?: any) => {
  noop();
};

@Directive()
export class ValueAccessorAbstract implements ControlValueAccessor, OnInit {
  protected onTouchedCallback: () => void = noop;
  protected onChangeCallback: (_: string) => void = noop;
  protected onInit = emptyFnWithParameter;
  private formControl: NgControl;
  public control: FormControl;
  @Input() errorMessage = 'Bitte korrigieren Sie die Eingabe.';

  protected innerValue = '';

  @Input() formControlName: string;

  protected constructor(protected injector: Injector) { }
  ngOnInit(): void {
    this.formControl = this.injector.get(NgControl, null);
    this.control = new FormControl();
    this.onInit();
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: (_: string) => void) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: () => void) {
    this.onTouchedCallback = fn;
  }

  get isInvalid() {
    if (this.formControl) {
      return this.formControl
        ? this.formControl.invalid &&
        (this.formControl.dirty || this.formControl.touched)
        : false;
    } else {
      return false;
    }
  }

  get hasError(): boolean {
    return this.isInvalid && this.formControl?.errors?.typ === 'error';
  }

  get value(): string {
    return this.innerValue;
  }

  set value(v: string) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  writeValue(value: string) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }
}
